export default __webpack_public_path__ + "static/media/lamp.9314de93.png";